import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileSystemFileEntry, UploadEvent } from 'ngx-file-drop';
import { CategoryService } from '../../../category/services/category.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { CamerallaAuthService } from '../../../../shared/services/authentication-services/cameralla-auth.service';
import * as $ from 'jquery';
import { Observable, of } from 'rxjs';
import { GlobalVariables } from '../../../../shared/models/cameralla-global.model';
import { CamerallaUser } from '../../../../shared/models/cameralla-user.model';
import { UserService } from '../../../user/services/user.service';
import { TagInputComponent } from "ngx-chips";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GeoLocationService } from "../../../../shared/services/geo-location.service";
import { UploadVideoService } from "../../service/upload-video.service";
import { PermissionAdminService } from "../../../../shared/services/guard-services/permission-admin.service";
import AppShareHelper from "../../../../shared/utils/helper";

@Component({
  selector: 'app-video-upload',
  templateUrl: './upload-video.component.html',
  providers: [GeoLocationService]
})
export class UploadVideoComponent implements OnInit {
  @ViewChild('inputTag')
  inputTag: TagInputComponent;
  
  static readonly maxWidthMobile = 991;
  static readonly maxFileSize = 200000000;
  currentPartner = GlobalVariables.CURRENT_PARTNER;
  fileList: FileList;
  file: File;
  formData: FormData;
  items = [];
  model: any = {
    category: {}
  };
  localUserId;
  categories: any[];
  formValid = true;
  editMode = false;
  photoSelected = true;
  form = new FormGroup({});
  tagMo: string[] = [];
  maxLength = 500;
  userProfile: CamerallaUser;
  uploading = false;
  isChecked = false;
  uploadProgress: any = "0%";
  loaded = false;
  intervalId = null;
  
  fields: FormlyFieldConfig[] = [];
  
  homeRoute = GlobalVariables.HOME_ROUTE;
  partnerObjects = GlobalVariables.partnerObjects;
  partnerNavigators = GlobalVariables.partnerNavigators;
  sourceObjects = GlobalVariables.sourceObjects;
  isAdmin = false;
  vipMember = false;
  
  constructor(private router: Router,
              private http: HttpClient,
              private toastr: ToastrService,
              private service: UploadVideoService,
              private categoryService: CategoryService,
              private authService: CamerallaAuthService,
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private userService: UserService) {
    this.localUserId = +this.authService.getLocalUserInfo()['id'];
  }
  
  ngAfterViewInit() {
  }
  
  ngOnInit() {
    this.userService.getUserInformation(this.localUserId).then(
      (resolve: any[]) => {
        this.isAdmin = (resolve[0].role == PermissionAdminService.adminConst);
        this.vipMember = AppShareHelper.checkVipMember(resolve[0].accessLevel);
        if (this.route.snapshot.params.id) {
          this.service.getVideo(this.route.snapshot.params.id).subscribe((res: any) => {
            if (res.Data) {
              if (res.Data.customerId != this.localUserId && !this.isAdmin) {
                this.router.navigate([`/videos`]);
              }
              
              this.loaded = true;
              this.editMode = true;
              this.model = res.Data;
              
              if (this.model.tags) {
                this.model.tags = this.model.tags.split(',')
              }
  
              this.categoryService.getCategories().toPromise().then(
                response => {
                  this.categories = response['Data'];
                  this.model.category = this.model.category || this.categories[18];
                },
              );
              
              if (this.model.status == 'in_progress') {
                this.intervalId = setInterval(() => {
                  this.service.getVideo(this.route.snapshot.params.id).subscribe((res: any) => {
                    if (res.Data && res.Data.status === 'done') {
                      this.model = res.Data;
                      clearInterval(this.intervalId);
                    }
                  })
                }, 10000);
              }
            }
          })
        } else {
          this.loaded = true;
        }
      }
    );
  }
  
  public fileChange(event) {
    this.fileList = event.target.files;
    
    if (this.fileList.length > 0) {
      if (this.service.fileTypes.indexOf(this.fileList[0].type) + 1) {
        this.file = this.fileList[0];
        this.setLocalPreview(this.file);
      } else {
        this.toastr.error('File type not allowed', 'Error');
      }
    }
  }
  
  delete() {
    if (confirm("Are you sure?")) {
      this.service.delete(this.model.id).subscribe(res => {
        this.service.deletedPhotoId = this.model.id;
        this.router.navigate([`/videos`]);
      })
    }
  }
  
  public upload(f: NgForm) {
    if (this.file && this.file.name) {
      if (f.valid) {
        this.uploading = true;
        this.formValid = true;
        this.formData = new FormData();
        this.formData.append('video', this.file, this.file.name);
        this.formData.append('customerId', this.localUserId);
        this.formData.append('title', this.model.title);
        
        let filename = this.file.name;
        let extension = filename.split(".").pop();
        
        let uniqueId = '_' + Math.random().toString(36).substr(2, 9) + '_' + this.localUserId + '.' + extension;
        let loaded = 0;
        let step = 1048576 * 25;// 25mb
        let total = this.file.size;
        let start = 0;
        let reader = new FileReader();
        let blob = this.file.slice(start, step);
        reader.readAsArrayBuffer(blob);
        
        reader.onload = (e) => {
          var fd = new FormData();
          fd.append('filedata', new File([reader.result], 'filechunk'));
          fd.append('loaded', String(loaded));
          fd.append('customerId', this.localUserId);
          fd.append('title', this.model.title);
          fd.append('sequenceId', uniqueId);
          
          if ((loaded + step) >= total) {
            fd.append('lastChunk', "true");
          }
          
          this.service.uploadOriginal(fd).subscribe((data: any) => {
            loaded += step;
            this.uploadProgress = (loaded / total * 100).toFixed(0) + '%';
            if (loaded <= total) {            // if file is not completely uploaded
              blob = this.file.slice(loaded, loaded + step);  // getting next chunk
              reader.readAsArrayBuffer(blob);        //reading it through file reader which will call onload again. So it will happen recursively until file is completely uploaded.
            } else {                       // if file is uploaded completely
              loaded = total;
              this.uploading = false;// just changed loaded which could be used to show status.
              if (data.Data) {
                this.toastr.success('Upload file successfully', 'Success');
                this.router.navigate([`/videos/${data.Data.id}`]);
              }
            }
          }, error => {
          
          });
        };
        
        
      } else {
        this.photoSelected = false;
        this.formValid = false;
        this.topFunction();
      }
    }
  }
  
  public dropped(event: UploadEvent) {
    if (event.files) {
      const droppedFile = event.files[0];
      
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        
        fileEntry.file((file: File) => {
          if (this.service.fileTypes.indexOf(file.type) + 1) {
            this.file = file;
            this.setLocalPreview(this.file);
          } else {
            this.toastr.error('Files not allowed', 'Error');
          }
        });
      } else {
        this.toastr.error('Only one file can be dropped', 'Error');
      }
    }
  }
  
  public getDefautTag() {
  
  }
  
  public setLocalPreview(file: File) {
    setTimeout(() => {
      const videoSrc: any = document.querySelector("#video-source");
      const videoTag: any = document.querySelector("#video-tag");
      const inputTag: any = document.querySelector("#input-tag");
      
      this.photoSelected = true;
      if (file.size < UploadVideoComponent.maxFileSize) {
        const reader = new FileReader();
        reader.onload = function (e) {
          videoSrc.src = e.target.result
          videoTag.load()
        }.bind(this)
        
        reader.readAsDataURL(file);
      } else {
        this.toastr.error('Max file size exceeds 200MB', 'Error');
      }
    }, 2000)
  }
  
  
  selectCategory(category) {
    this.model.category = category;
  }
  
  selectPartner(partner) {
    if (partner.id === 2 && !this.checkSizeWindowMobile()) {
      this.selectSource(this.sourceObjects.SYSTEM);
    }
  }
  
  selectSource(source) {
    $('#photoSource').removeClass('text-danger');
  }
  
  update() {
    this.service.updateVideo(this.model.id, this.model).subscribe(res => {
      this.toastr.success('Update video successfully', 'Success');
    })
  }
  
  topFunction() {
    $('html, body').animate({scrollTop: 0}, 'slow');
  }
  
  failValidation() {
  }
  
  public onAdding(tag: string): Observable<any> {
    return of(tag.toLocaleLowerCase());
  }
  
  public checkSizeWindowMobile() {
    return screen.width <= UploadVideoComponent.maxWidthMobile;
  }
  
  
  ngOnDestroy() {
  }
}
